var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    width: 26,
    height: 26,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.6,10.5H11l-0.2-0.2c0.7-0.9,1.2-2,1.2-3.2c0-2.7-2.2-4.9-4.9-4.9c-2.7,0-4.8,2.2-4.8,4.9 c0,0.4,0.1,0.8,0.1,1.1c0.4-0.3,0.8-0.5,1.3-0.7c0-0.1,0-0.3,0-0.4c0-1.9,1.5-3.4,3.4-3.4c1.9,0,3.4,1.5,3.4,3.4 c0,0.9-0.3,1.7-0.9,2.3c0.3,0.4,0.5,0.9,0.7,1.4l0.2,0.2v0.6l3.8,3.7l1.1-1.1L11.6,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.8,11.6c0-0.8-0.5-1.4-1.3-1.4c-0.7,0-1.3,0.6-1.3,1.4c0,1.1,0.6,1.6,1.3,1.6S6.8,12.7,6.8,11.6z M5.5,12.4 c-0.3,0-0.5-0.2-0.5-0.8C5,11.2,5.2,11,5.5,11c0.4,0,0.6,0.2,0.6,0.6C6.1,12.2,5.8,12.4,5.5,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.5,8.2c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4s4-1.8,4-4C9.5,10,7.7,8.2,5.5,8.2z M5.5,15.2 c-0.7,0-1.3-0.3-1.8-0.7c0.2-0.3,0.9-0.4,1.8-0.4c1,0,1.7,0.1,1.9,0.4C6.9,14.9,6.2,15.2,5.5,15.2z M7.9,13.9 c-0.4-0.5-1.2-0.7-2.4-0.7s-2,0.2-2.4,0.7c-0.3-0.5-0.5-1.1-0.5-1.7c0-1.6,1.3-2.9,2.9-2.9s2.9,1.3,2.9,2.9 C8.4,12.9,8.2,13.4,7.9,13.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchUsers);
export default __webpack_public_path__ + "static/media/searchUsers.7a1de05d.svg";
export { ForwardRef as ReactComponent };